import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  ONE_C_CONTRACTS,
  ONE_C_CONTRACTS_STUDENT,
  ONE_C_SALARY_STAFF,
  STUDENT_PAYMENTS_BY_STUDENT,
  STUDENT_PAYMENTS_PRINCIPAL,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const paymentsPrincipal = createAsyncThunk(
  STUDENT_PAYMENTS_PRINCIPAL,
  async (
    params: PayloadCreatorParams<`${typeof API.STUDENT_PAYMENTS_PRINCIPAL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.paymentsPrincipal(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const paymentsByStudent = createAsyncThunk(
  STUDENT_PAYMENTS_BY_STUDENT,
  async (
    params: PayloadCreatorParams<`${typeof API.STUDENT_PAYMENTS_BY_STUDENT}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.paymentsByStudent(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const paymentsPrincipalClear = createAction(`${STUDENT_PAYMENTS_PRINCIPAL}/clear`)

export const oneCContracts = createAsyncThunk(
  ONE_C_CONTRACTS,
  async (params: PayloadCreatorParams<`${typeof API.ONE_C_CONTRACTS}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.oneCContracts(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const oneCContractsStudent = createAsyncThunk(
  ONE_C_CONTRACTS_STUDENT,
  async (params: PayloadCreatorParams<`${typeof API.ONE_C_CONTRACTS_STUDENT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.oneCContractsStudent(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const oneCSalaryStaff = createAsyncThunk(
  ONE_C_SALARY_STAFF,
  async (params: PayloadCreatorParams<`${typeof API.ONE_C_SALARY_STAFF}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.oneCSalaryStaff(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)
